export const PAGE_TYPES = {
  MM_PAGE: "MM page",
  VARIANT_PAGE: "Variant listing page",
  GALLERY_PAGE: "Gallery page",
  SPECS_PAGE: "Specs page",
  PRICE_PAGE: "Price page",
  DIMENSIONS_PAGE: "Dimensions page",
  COLOURS_PAGE: "Colours page",
  HOME_PAGE: "Homepage",
  SEARCH_PAGE: "Search page",
  COMPARISON_PAGE: "Comparison page",
  MMV_PAGE: "MMV page",
  MILEAGE_PAGE: "Mileage page",
  BUY_HOMEPAGE: "Buy Homepage",
  COLLECTION_PAGE: "Collection page",
  BUY_CAR_DROP_PAGE: "Buy car drop page",
  CAR_DROP_PAGE: "Car drop page",
  CAR_DROP_WINNER_DECLARATION_PAGE: "Car Drop Winner Declaration Page",
  REVIEW_PAGE: "Review page",
  IMAGE_PAGE: "Images page",
  FAQS_PAGE: "FAQs page",
  WISHLIST_PAGE: "Shortlist page",
  HELP_ME_BUY_PAGE: "Help me buy",
  RATINGS_CALCULATION: "Ratings Calculation",
  ONBOARDING_PAGE: "Onboarding page",
  MY_BOOKING_PAGE: "My booking page",
  MY_QUOTES_PAGE: "My quotes page",
  QUOTE_PAGE: "QuotePage",
  DEAL_CONFIRMATION_PAGE: "Deal Confirmation page",
  VARIANT_SELECTION_PAGE: "Variant Selection page",
  PAYMENT_SUCCESS_PAGE: "Payment Success page",
  BOOKING_CONFIRMATION_PAGE: "Booking Confirmation page",
  NOT_FOUND_PAGE: "Not Found page",
  VALUATION_REPORT_PAGE: "Valuation Report page",
  VALUATION_EDIT_DETAILS_PAGE: "Valuation Edit Car Details page",
  VALUATION_CONFIRM_DETAILS_PAGE: "Valuation Confirm Car Details page",
  VALUATION_LOCATION_SELECTION_PAGE: "Valuation Location selection page",
  VALUATION_ADDRESS_PAGE: "Valuation Address page",
  VALUATION_STEPS_TO_SELL: "Steps to sell page",
  VALUATION_DATES_AND_SLOTS_PAGE: "Valuation Date & slot selection page",
  VALUATION_SUCCESS_PAGE: "Valuation Success page",
  SPECS_AND_FEATURES: "Specs and features page",
  VARIANT_LISTING_PAGE: "Variant listing page",

} as const;

export type PageType = (typeof PAGE_TYPES)[keyof typeof PAGE_TYPES];
